import React, { useEffect, useState } from "react";
import { AgCharts } from "ag-charts-react";
import { baseColors } from "../../../../../utils/handlers";
import DropdownCategories from "../../Components/DropdownCategories";
import DynamicDropDownFilter from "../../Components/DynamicDropDownFilter";

function InflowCategoriesTrend({ data, type }) {
  const [graphData, setGraphData] = useState([]);
  const [series, setSeries] = useState([]);
  const [category, setCategory] = useState({
    category: "All Categories",
  });
  const [dropDownValues, setDropDownValues] = useState([]);
  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "₹--";
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 0,
      style: "currency",
      currency: "INR",
    });
  }

  const [filter, setFilter] = useState({
    name: "Overall",
    value: "overall_categorization",
  });
  const mapData = (data) => {
    if (!Object.keys(data)[0]) return [];
    const array = data[Object.keys(data)[0]]["x-axis"]?.map((key, index) => {
      const quarter = key;

      const subObject = Object.keys(data).reduce((acc, subkey) => {
        acc[subkey] = data[subkey]["y-axis"][index]; // Set the value to the second element
        return acc;
      }, {});
      return {
        quarter: quarter,
        ...subObject,
      };
    });

    return array;
  };
  const mapSeries = (data) => {
    if (category.category !== "All Categories") {
      const arrayIndividual = [];
      arrayIndividual.push({
        type: "line",
        xKey: "quarter",
        yKey: category.category,
        yName: category.category,
        stroke: baseColors[0],
        strokeWidth: 2,
        lineDash: [6, 3],
        marker: { enabled: false },
      });
      return arrayIndividual;
    }

    const array = Object.keys(data).map((item, index) => {
      return {
        type: "line",
        xKey: "quarter",
        yKey: item,
        yName: item,
        stroke: baseColors[index % baseColors.length],
        strokeWidth: 2,
        lineDash: [6, 3],
        marker: { enabled: false },
      };
    });

    return array;
  };
  const [options, setOptions] = useState({
    data: graphData,
    series: series,
    axes: [
      {
        type: "category",
        position: "bottom",
        gridLine: false,
        label: {
          fontSize: 9,
          fontWeight: "light",
        },
      },
      {
        type: "number",
        position: "left",
        gridLine: false,
        label: {
          formatter: (params) => {
            // Format with thousand separators and add a currency symbol
            return `${formatToIndianRupees(params.value)}`;
          },
          fontSize: 11,
          fontWeight: "light",
        },
      },
    ],
    legend: {
      item: {
        label: {
          fontSize: 11, // Change the legend font size

          fontWeight: "normal",
          color: "#637381", // Change the legend font color
        },
        marker: {
          size: 10, // Change the size of the color boxes
        },
      },
    },
    height: 300,
  });
  useEffect(() => {
    setGraphData(
      mapData(
        data !== undefined
          ? data[filter.value]?.category_monthwise_graphs?.[
              type === "inflow" ? "inflow" : "outflow"
            ]
          : []
      )
    );

    setSeries(
      mapSeries(
        data !== undefined
          ? data[filter.value]?.category_monthwise_graphs?.[
              type === "inflow" ? "inflow" : "outflow"
            ]
          : []
      )
    );
    setDropDownValues(
      data !== undefined
        ? [
            ...data[filter.value][
              type === "inflow"
                ? "overall_category_inflow"
                : "overall_category_outflow"
            ],
            ...[
              {
                category: "All Categories",
              },
            ],
          ]
        : []
    );
  }, [filter, data]);

  useEffect(() => {
    setSeries(
      mapSeries(
        data
          ? data[filter.value]?.category_monthwise_graphs?.[
              type === "inflow" ? "inflow" : "outflow"
            ]
          : []
      )
    );
  }, [category]);

  useEffect(() => {
    setOptions({ ...options, data: graphData, series: series });
  }, [graphData, series]);

  return (
    <div className=" w-[49.5%] rounded-lg border border-[#e6ebed] h-[347px] py-4 overflow-x-auto overflow-y-hidden">
      <div className=" px-4 flex justify-between  items-center w-full">
        <p className=" text-base font-semibold">
          {type === "inflow"
            ? "Inflow Categories Trends"
            : "Outflow Categories Trends"}
        </p>
        <DropdownCategories filterValue={filter} setFilterValue={setFilter} />
        <DynamicDropDownFilter
          dropDownValues={dropDownValues}
          filterValue={category}
          setFilterValue={setCategory}
        />
      </div>
      <div className="h-full mt-1 ">
        {" "}
        <AgCharts options={options} />{" "}
      </div>
    </div>
  );
}

export default InflowCategoriesTrend;
